import { Navbar } from "react-bootstrap";
import NavigateBackButton from "./navigateBackButton/NavigateBackButton";
import ContentHeaderTitle from "./contentHeaderTitle/ContentHeaderTitle";
import { useState } from "react";
import ContentHeaderMapWidgets from "./contentHeaderWidgets/map/Widgets";
import ContentHeaderRoadsListWidgets from "./contentHeaderWidgets/roadsList/Widgets";
import ContentHeaderRoadWebCameraWidgets from "./contentHeaderWidgets/roadWebCamera/Widgets";
import ContentHeaderPanoramaWidgets from "./contentHeaderWidgets/panorama/Widgets";
import ContentHeaderPathNormativitiesInfoWidgets from "./contentHeaderWidgets/pathNormativitiesInfo/Widgets";
import ContentHeaderCardWidgets from "./contentHeaderWidgets/card/Widgets";
import ContentHeaderTableWidgets from "./contentHeaderWidgets/table/Widgets";
import ContentHeaderDevExtremeTableWidgets from "./contentHeaderWidgets/devExtremeTable/Widgets";

export default function ContentHeader({ objectTypeName, title, type, option, filterRoute, filterButtonTitle }: any) {
    const [isExpanded, setIsExpanded] = useState<boolean>(false)

    return (
        <Navbar expanded={isExpanded} expand="md" className="content-header-div">
            <NavigateBackButton />
            <ContentHeaderTitle title={title} />
            {type
                ?
                <>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" onClick={() => setIsExpanded(!isExpanded)} />
                    <Navbar.Collapse id="responsive-navbar-nav" >
                        <div className="content-header-widgets-div">
                            {type === "map" &&
                                <ContentHeaderMapWidgets
                                    objectTypeName={objectTypeName}
                                    mapType={option}
                                    filterRoute={filterRoute}
                                    filterButtonTitle={filterButtonTitle}
                                />
                            }
                            {type === "search" &&
                                <ContentHeaderRoadsListWidgets />
                            }
                            {type === "camera" &&
                                <ContentHeaderRoadWebCameraWidgets />
                            }
                            {type === "panorama" &&
                                <ContentHeaderPanoramaWidgets />
                            }
                            {type === "pathNormativitiesInfo" &&
                                <ContentHeaderPathNormativitiesInfoWidgets />
                            }
                            {type === "card" &&
                                <ContentHeaderCardWidgets cardType={option} />
                            }
                            {type === "table" &&
                                <ContentHeaderTableWidgets tableType={option} />
                            }
                            {type === "devExtremeTable" &&
                                <ContentHeaderDevExtremeTableWidgets />
                            }
                        </div>
                    </Navbar.Collapse>
                </>
                :
                <div className="fake-layout-block" />
            }
        </Navbar>
    )
}
